import { compose, lensProp, mapObjIndexed, over, path } from 'ramda';

import {
  ContactUsReceiptCMSDataContract,
  Label,
  LabelAndValidation,
} from '../../../models/contact-us-receipt.models';
import {
  ContactUsMainContentUnwrapped,
  ContractTextFields,
} from './contact-us-receipt.type';

export const unwrapComponentMainContent: (
  input: ContactUsReceiptCMSDataContract,
) => ContactUsMainContentUnwrapped = compose(
  (mapObjIndexed as any)(
    compose(
      over(lensProp('validationLabels'), path([0])),
      path<LabelAndValidation | Label>([0]),
    ),
  ),
  path<ContractTextFields>(['contactUsReceipt', 0]),
);
